//#region IMPORTS
import React from 'react';
//redux
import { getConciliationList } from '../../redux/conciliationMonitor.duck';
import ConciliationPartial from './shared/ConciliationPartial';
//#endregion IMPORTS

const PartialDaily = ({ data, columns = [] }) => (
  <ConciliationPartial
    data={data}
    fetchAction={getConciliationList}
    columns={columns}
    highlightOnHover={true}
    inlineFilters
  />
);
export default PartialDaily;
